// extracted by mini-css-extract-plugin
export default {"card":"_22jC3-Go","avatar":"_1MK8X9cG","copy":"_3k0nb0vF","heading":"jGabNDzT","headingDesktop":"_1SkgMQF6","headingMobile":"_2DDGVhFL","body":"_2XpJALDM","button":"_3S5eKjob"};